<template>
  <div class="flex items-center gap-8 min-w-0">
    <BittsAvatar
      v-bind="avatarProps"
      :show-initials="true"
      size="x-small"
      class="shrink-0"
    />
    <span class="text-sm font-bold truncate min-w-0" :title="label">
      {{ label }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { BittsAvatar } from '@crossbeam/bitts';

import { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import {
  CreditUsageClient,
  CreditUsageUser,
} from '@/composables/credits/useCreditUsage';
import { getClientDomain } from '@/constants/credit_clients';

type CreditUsageRow = CreditUsageClient | CreditUsageUser;

const { params } = defineProps<{
  params: ICellRendererParams<CreditUsageRow> & { kind: 'client' | 'user' };
}>();

const label = computed(() => {
  if (params.kind === 'client')
    return (
      (params.data as CreditUsageClient | undefined)?.client ?? 'Unknown client'
    );
  return (params.data as CreditUsageUser | undefined)?.name ?? 'Unknown user';
});

const avatarProps = computed(() => {
  if (params.kind === 'client') {
    const client = params.data as CreditUsageClient | undefined;
    return {
      shape: 'square' as const,
      org: { name: label.value, domain: getClientDomain(client?.client) },
    };
  }
  const user = params.data as CreditUsageUser | undefined;
  return {
    user: {
      first_name: user?.name,
      email: user?.email,
      picture_url: user?.picture_url,
    },
  };
});
</script>
